import {
  DataTableSettings,
  UseDataTableOptions,
} from "@/types/dataTableSettings";
import { useContext } from "react";
import { DataTableSettingsContext } from "../DataTableSettingsContext";

export const useDataTableOptions = <TData,>(): UseDataTableOptions<TData> => {
  const { options } = useContext(
    DataTableSettingsContext as React.Context<DataTableSettings<TData>>,
  );
  return options;
};
